import { render } from "./NotificationBadge.vue?vue&type=template&id=9717c886&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"

import "./NotificationBadge.vue?vue&type=style&index=0&id=9717c886&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9717c886"]])

export default __exports__